module.exports = __webpack_public_path__ + "img/puertorico.7acf5cc8.svg";